import type { TransitionMeetingProgressResource } from "api/generated";
import type { TransitionMeetingProgress } from "meetings/advisory/types";
import { teacherScoreFromDto } from "./teacherScore.mapper";
import { timeframeSettingsFromDto } from "./timeframe.mapper";

export const meetingProgressFromDto = (
  dto: TransitionMeetingProgressResource,
): TransitionMeetingProgress => ({
  id: dto.id,
  name: dto.name,
  status: dto.status as TransitionMeetingProgress["status"],
  meetingType: "transition_meeting",
  totalRatings: dto.total_ratings,
  totalGivenRatings: dto.total_given_ratings,
  progressPercentage:
    dto.total_ratings > 0
      ? Math.round((dto.total_given_ratings / dto.total_ratings) * 100)
      : 0,
  teacherScores: dto.teacher_scores.map(teacherScoreFromDto),
  timeframeSettings: timeframeSettingsFromDto(dto.timeframe_settings),
});
